import { message } from 'antd';

import { store } from '../../redux/store';
import { addGuestCartItem } from '../../redux/slices/shoppingCartSlice';
import { createCartItem, fetchCartItemsSelectionsByIds } from '../../services';
import type { AddProductToCartArgs } from '../interfaces';



const isSameSelection = (
  item: { product: { id: string }; selectedMaterial: string; selectedSize?: string | null },
  productId: string,
  selectedMaterial: string,
  selectedSize?: string | null
) =>
  item.product.id === productId &&
  item.selectedMaterial === selectedMaterial &&
  (item.selectedSize ?? '') === (selectedSize ?? '');

export const addProductToCart = async ({
  dispatch,
  curProduct,
  selectedMaterial,
  selectedSize,
  price,
  requiresSize,
  userId,
}: AddProductToCartArgs) => {
  if (!userId) {
    const guestCartItems = store.getState().shoppingCart.cartItems;
    const isDuplicateGuestItem = guestCartItems.some((item) =>
      isSameSelection(item, curProduct.id, selectedMaterial, selectedSize)
    );

    if (isDuplicateGuestItem) {
      message.warning('This item is already in your cart.');
      return;
    }

    dispatch(addGuestCartItem({
      id: `guest-${curProduct.id}-${selectedMaterial}-${selectedSize || 'no-size'}-${Date.now()}`,
      selectedMaterial,
      selectedSize: selectedSize || '',
      size: selectedSize || '',
      material: selectedMaterial,
      quantity: 1,
      price,
      productPrice: price,
      materialPrice: price,
      product: {
        id: curProduct.id,
        title: curProduct.title,
        productType: curProduct.productType,
        price: String(price),
        materialPrices: curProduct.materialPrices,
        sizes: curProduct.sizes,
      },
      user: { id: 'guest', name: 'Guest' },
      sizeErrors: [],
    }));

    message.success('Item added to cart successfully!');
    return;
  }

  const ids = store.getState().shoppingCart.addedTooCartProductCountAndIds.ids;
  const existingSelections = ids.length > 0
    ? await dispatch(fetchCartItemsSelectionsByIds(ids)).unwrap()
    : [];
  const isDuplicate = existingSelections.some((item) =>
    isSameSelection(item, curProduct.id, selectedMaterial, selectedSize)
  );

  if (isDuplicate) {
    message.warning('This item is already in your cart.');
    return;
  }

  await dispatch(createCartItem({
    userId,
    productId: curProduct.id,
    selectedMaterial,
    price,
    ...(requiresSize && selectedSize && { selectedSize }),
  })).unwrap();

  message.success('Item added to cart successfully!');
};
